import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function ClientsCarousel() {
  const [clients, setClients] = useState([]);
  useEffect(() => {
    api.get("/clients").then(setClients).catch(() => setClients([]));
  }, []);

  return (
    <section className="py-20 border-y border-border bg-secondary/30" data-testid="clients-carousel">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10">
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">Trust</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
          Marcas que pueden crecer con <span className="gradient-text">INFLUCAST</span>
        </h2>
      </div>
      <Marquee gradient={false} speed={40} pauseOnHover>
        {clients.length === 0
          ? Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="mx-6 h-20 w-44 border border-border rounded-sm flex items-center justify-center text-muted-foreground/60 font-display font-bold tracking-tight">
                MARCA {i + 1}
              </div>
            ))
          : clients.map((c) =>
              c.logo ? (
                <a key={c.id} href={c.link || "#"} className="mx-6 h-20 w-44 px-4 py-3 grayscale hover:grayscale-0 transition-all flex items-center justify-center" data-testid={`client-logo-${c.id}`}>
                  <img src={c.logo} alt={c.name} className="max-h-full max-w-full w-auto h-auto object-contain" />
                </a>
              ) : (
                <div key={c.id} className="mx-6 h-20 w-44 border border-border rounded-sm flex items-center justify-center text-muted-foreground font-display font-bold tracking-tight uppercase text-sm text-center px-2">
                  {c.name}
                </div>
              )
            )}
      </Marquee>
    </section>
  );
}
